export type SidekickConversation = {
  id: string;
  title: string;
  when: string;
  isCurrent?: boolean;
};

export const PAGE_SIZE = 8;

export const MOCK_CONVERSATIONS: SidekickConversation[] = [
  {
    id: 'c1',
    title: 'Debug conversation #119127',
    when: 'Today · 14:32',
    isCurrent: true,
  },
  {
    id: 'c2',
    title: 'Create a delivery support AI agent',
    when: 'Today · 11:48',
  },
  {
    id: 'c3',
    title: 'Review vegetarian meal substitutions',
    when: 'Yesterday · 16:20',
  },
  { id: 'c4', title: 'Update the refund procedure', when: 'Yesterday · 14:05' },
  {
    id: 'c5',
    title:
      'Investigate a missed delivery that has a very long title that is very long, almost comically long, and is probably going to be truncated in the UI',
    when: '14 Sep · 09:42',
  },
  { id: 'c6', title: 'Add subscription FAQs', when: '13 Sep · 15:18' },
  { id: 'c7', title: 'Improve order-routing rules', when: '12 Sep · 10:06' },
  { id: 'c8', title: 'Test the billing AI agent', when: '11 Sep · 13:24' },
  { id: 'c9', title: 'Draft a holiday closure macro', when: '10 Sep · 16:51' },
  {
    id: 'c10',
    title: 'Summarise last week escalations',
    when: '09 Sep · 11:37',
  },
  { id: 'c11', title: 'Explain the CSAT drop', when: '08 Sep · 09:15' },
  { id: 'c12', title: 'Rewrite the welcome greeting', when: '05 Sep · 14:48' },
  {
    id: 'c13',
    title: 'Audit unused knowledge articles',
    when: '04 Sep · 10:29',
  },
  { id: 'c14', title: 'Check the Shopify order tool', when: '03 Sep · 15:02' },
];
